const provinces = [
  { id: 1, name: "Архангай" },
  { id: 2, name: "Баян-Өлгий" },
  { id: 3, name: "Баянхонгор" },
  { id: 4, name: "Булган" },
  { id: 5, name: "Говь-Алтай" },
  { id: 6, name: "Говьсүмбэр" },
  { id: 7, name: "Дархан-Уул" },
  { id: 8, name: "Дорноговь" },
  { id: 9, name: "Дорнод" },
  { id: 10, name: "Дундговь" },
  { id: 11, name: "Завхан" },
  { id: 12, name: "Өвөрхангай" },
  { id: 13, name: "Өмнөговь" },
  { id: 14, name: "Орхон" },
  { id: 15, name: "Сүхбаатар" },
  { id: 16, name: "Сэлэнгэ" },
  { id: 17, name: "Төв" },
  { id: 18, name: "Увс" },
  { id: 19, name: "Ховд" },
  { id: 20, name: "Хөвсгөл" },
  { id: 21, name: "Хэнтий" },
  { id: 22, name: "Улаанбаатар" },
];

const dates = [
  { id: 1, name: "1-р ээлж (6/21-6/28)" },
  { id: 2, name: "2-р ээлж (6/28-7/05)" },
];

export default { provinces, dates };